// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__LSrcH","messages":"Chat_messages__Rw4BO","dateDivider":"Chat_dateDivider__9nNF5"};